import {AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {BASE_GREY, Tools} from 'linkurious-shared';

@Component({
  selector: 'type-list',
  template: `<div class="types-wrapper types--{{direction}}">
  <ng-template ngFor let-type [ngForOf]="sanitizeTypes" let-i="index" [ngForTrackBy]="trackByName">
    <div class="type"
         *ngIf="!isLimitOn || (isLimitOn && i < limit)"
         [class.editable]="editable"
         [style.background]="( colors[type] ) ? colors[type] : '#0081E3'"
         [style.color]="colorLabel[i]">
      <truncate [value]="type" [limit]="truncateLimit"></truncate>
      <icon *ngIf="editable"
            class="type__cross"
            name="close"
            [stroke]="5"
            [size]="9"
            (click)="removeElement(i)"></icon>
    </div>
  </ng-template>
  <div class="out-limit" *ngIf="isLimitOn">
  +{{ outOfLimit }}
</div>
</div>

`,
  styles: [`.types-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-content:center;align-items:flex-start}.types-wrapper.types--left{justify-content:flex-start}.types-wrapper.types--right{justify-content:flex-end}.types-wrapper .type{padding:5px 7px;font-size:12px;border-radius:3px;color:#fff;margin-right:5px;margin-bottom:5px;white-space:nowrap}.types-wrapper .type:last-child{margin-right:0}.types-wrapper .type.editable{padding:5px 7px}.types-wrapper .type.fitted{flex:0}.types-wrapper .type .type__cross{position:relative;top:2px;height:9px;margin-left:10px;cursor:pointer}.types-wrapper .out-limit{padding:2px 7px 3px;font-size:14px;border:1px solid #878787;border-radius:3px;margin-bottom:5px;background:#fff;color:#878787;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}`]
})
export class TypeListComponent implements OnChanges, AfterViewInit, OnInit {

  @Input() types: Array<string>;
  @Input() colors: { [key: string]: string } = {};
  @Input() limit: number;
  @Input() editable: boolean;
  @Input() truncation: string;
  @Input() direction: 'left'|'right' = 'left';
  @Output() listUpdate: EventEmitter<number> = new EventEmitter<number>();
  public sanitizeTypes: Array<string>;
  public colorLabel: Array<string> = [];

  public isLimitOn: boolean = false;
  public outOfLimit: number;
  public truncateLimit: string = 'fit';

  constructor(private _elementRef: ElementRef, private _detectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.getTruncateOptions();
  }

  ngOnChanges() {
    this.sanitizeTypes = this.types.filter(t => Tools.valueExists(t) && Tools.isStringFilled(t));
    if ( Tools.isDefined(this.sanitizeTypes) ) {
      if ( !Tools.isDefined(this.colors) ) {
        this.colors = {};
      }
      setTimeout(() => {
        this.colorLabel = [];
        for (let i = 0; i < this.sanitizeTypes.length; ++i) {
          this.colorLabel.push(this.getLabelColor(i));
        }
        this._detectorRef.markForCheck();
      }, 0);
      this.isLimitOn = ( Tools.isDefined(this.limit) ) ? this.sanitizeTypes.length > this.limit : false;
      if( this.isLimitOn ) {
        this.outOfLimit = this.sanitizeTypes.length - this.limit
      }
    }
  }

  ngAfterViewInit() {
    this.getTruncateOptions();
    this._detectorRef.markForCheck();
  }

  trackByName(index: number, name: string): string {
    return name;
  }

  public getTruncateOptions() {
    if( Tools.isDefined(this.truncation) ) {
      this.truncateLimit = this.truncation;
    } else {
      this.truncateLimit = this._elementRef.nativeElement.getBoundingClientRect().width + 'px';
    }
  }

  public removeElement(index: number) {
   this.listUpdate.emit(index);
  }

  public getLabelColor(index: number): '#000'|'#FFF' {
    if ( Tools.isDefined(this._elementRef.nativeElement.querySelectorAll('.type')[index])) {
      let computedColor = window.getComputedStyle(this._elementRef.nativeElement.querySelectorAll('.type')[index]).backgroundColor;
      return ( Tools.isDefined(computedColor) && Tools.isBright(computedColor) ) ? '#000' : '#FFF';
    }
    return '#FFF';
  }
}
